import { Expose } from "class-transformer";
import { Model } from "./model";
import { NotificationType } from "../../common";

export class NotificationsModel extends Model {
    @Expose() id: string;
    @Expose() title: string;
    @Expose() body: string;
    @Expose() isRead: boolean;
    @Expose() type: NotificationType;
}